import { isNullOrUndefined } from 'util';

export const capitalize = (value: string) => {
  return (value) ? value.charAt(0).toUpperCase() + value.slice(1) : value;
};

const reduceCapitalized = (acc: string, word: string) => acc.concat(' ', capitalize(word));

export const capitalizeAll = (value: string) => {
  return (value) ? value.split(' ').reduce(reduceCapitalized, '') : value;
};

export const matches = (haystack: string, needle: string) => {
  const lowHaystack = (haystack) ? haystack.toLowerCase() : '';
  const lowNeedle = (needle) ? needle.toLowerCase() : '';

  return (!lowNeedle || (lowHaystack && lowHaystack.includes(lowNeedle)));
};

export const compare = (a: string, b: string) => a && b ? a.localeCompare(b) : null;

export const underscore = (value: string) => (value) ? value.replace(' ', '_') : value;

export const valueOf = (value: Object) => (isNullOrUndefined(value)) ? null : value.toString();



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/string.utils.ts